module.exports = __webpack_public_path__ + "img/7800.61d88d25.jpg";